import { EditIcon } from "assets/icons/Edit";
import TrashIcon from "assets/icons/TrashIcon";
import { useCampaignsStore } from "screens/Campaigns/store";
import { IProject } from "screens/Campaigns/types";

export const ProjectCard = ({
  project,
  deleteProject
}: {
  project: IProject;
  deleteProject: (id: string) => void;
}) => {
  const { setIsOpenAddProjectForm, setSelectedProject } = useCampaignsStore();

  return (
    <>
      <div>
        <p className="text-[#DADADA99]">Logo:</p>
        <img
          src={project.project_url}
          alt="project-logo"
          className="w-20 h-20 rounded-full overflow-hidden"
        />
      </div>
      <p>
        <span className="text-[#DADADA99]">Title:</span> {project.title}
      </p>
      <p>
        <span className="text-[#DADADA99]">Twitter url:</span>{" "}
        <a href={project.x_url} rel="noreferrer" target="_blank">
          <p className="truncate">{project.x_url}</p>
        </a>
      </p>
      <div className="absolute top-0 right-0 flex gap-[8px] bg-[#111111] pl-2 pb-2">
        <button
          className="dapp-page--grid-item--action"
          aria-label="Open"
          onClick={(e) => {
            e.stopPropagation();
            setSelectedProject(project);
            setIsOpenAddProjectForm(true);
          }}
        >
          <EditIcon width={14} height={14} />
        </button>
        <button
          className="dapp-page--grid-item--action-delete"
          aria-label="Open"
          onClick={(e) => {
            e.stopPropagation();
            deleteProject(project.id);
          }}
        >
          <TrashIcon width={16} height={16} />
        </button>
      </div>
    </>
  );
};
